import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAL3uc6BwCyaI18LLO37s_yQqZSzgymeUg",
  authDomain: "gemistruct-gen1.firebaseapp.com",
  projectId: "gemistruct-gen1",
  storageBucket: "gemistruct-gen1.appspot.com",
  messagingSenderId: "968112783931",
  appId: "1:968112783931:web:1adb73d321c0c4c30c521e"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app; 